import { Link } from "react-router-dom";
import { CalendarCheck, Navigation, Phone } from "lucide-react";
import { HOURS, SITE, TEL, parisNow } from "../../lib/site";
import { OpenBadge } from "./OpenBadge";
import { Reveal } from "./Reveal";

export function HoursList() {
  const today = parisNow().day;
  return (
    <ul className="divide-y divide-slate-200" data-testid="hours-list">
      {HOURS.map((h) => (
        <li key={h.day} className={`flex items-center justify-between py-2.5 text-sm ${h.d === today ? "font-bold text-ag-navy" : "text-slate-700"}`}>
          <span className="flex items-center gap-2">{h.d === today && <span className="h-1.5 w-1.5 rounded-full bg-ag-blue" />}{h.day}</span>
          <span className="font-mono">{h.open ? `${h.open} – ${h.close}` : "Fermé"}</span>
        </li>
      ))}
    </ul>
  );
}

export function LocationSection({ title = "A+ Glass Pare-Brise Haguenau" }) {
  return (
    <section id="localisation" className="px-5 py-24 lg:px-8" data-testid="location-section">
      <div className="mx-auto grid max-w-[1320px] gap-6 lg:grid-cols-12">
        <Reveal className="rounded-[2rem] bg-white p-8 ring-1 ring-slate-200 sm:p-10 lg:col-span-5">
          <p className="eyebrow">Localisation & horaires</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-ag-ink sm:text-4xl">{title}</h2>
          <address className="mt-6 not-italic">
            <p className="text-lg font-semibold text-ag-ink" data-testid="location-address">{SITE.street}<br />{SITE.zip} {SITE.city}</p>
            <a href={TEL} className="mt-2 inline-block font-display text-2xl font-extrabold text-ag-blue" data-testid="location-phone">{SITE.phone}</a>
          </address>
          <div className="mt-6 flex flex-wrap gap-2">
            <a href={SITE.mapsDir} target="_blank" rel="noopener noreferrer" className="btn btn-navy" data-testid="location-directions-button"><Navigation className="h-4 w-4" />Itinéraire</a>
            <a href={TEL} className="btn btn-blue" data-testid="location-call-button"><Phone className="h-4 w-4" />Appeler</a>
            <Link to="/devis?mode=rendez-vous" className="btn btn-outline" data-testid="location-rdv-button"><CalendarCheck className="h-4 w-4" />Prendre rendez-vous</Link>
          </div>
          <div className="mt-8">
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <h3 className="font-display text-lg font-bold text-ag-ink">Nos horaires</h3>
              <OpenBadge testid="location-open-badge" />
            </div>
            <HoursList />
          </div>
        </Reveal>
        <Reveal delay={0.1} className="min-h-[380px] overflow-hidden rounded-[2rem] ring-1 ring-slate-200 lg:col-span-7">
          <iframe title="Carte Google Maps — A+GLASS Pare-Brise HAGUENAU, 101A Route de Marienthal" src={SITE.mapsEmbed} className="h-full min-h-[380px] w-full border-0 grayscale-[30%]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="location-map" />
        </Reveal>
      </div>
    </section>
  );
}
